import React from 'react'
import { useParams } from 'react-router-dom'
import EventSidebar from './EventSidebar'
import EventTiles from './EventTiles'
import EventBreadcrumb from './EventBreadcrumb'
import EventSkeleton from './EventSkeleton'
import useLoad from '../functions/useLoad'
import { loadEvent, loadWpPages } from '../apis/publicApi'
import joinWpTiles from '../functions/joinWpTiles'
import eventTrail from '../functions/eventTrail'
import { LABELS } from '../constants/staticText'
import { useDocumentTitle } from '../../lib/a11y/useDocumentTitle'
import { useFocusHeading } from '../../lib/a11y/useFocusHeading'

// Die Kachelseite einer Messe: Sidebar, Weg zur Seite, Kachelraster. Die
// Abschnitte liegen seit #82 in eigener View (EventSectionView) — mit ihnen sind
// hier der Abschnittssprung und der Ausstellerabruf entfallen, den nur der
// Abschnitt brauchte.
const EventHub = () => {
    const { eventSlug } = useParams()
    const event = useLoad(() => loadEvent(eventSlug), [eventSlug])
    // WP-Seiten der Site (#60, #201): unabhaengig vom Event abrufbar, der Join
    // der wpPage-Kacheln laeuft ueber die Seiten-Id.
    const wpPages = useLoad(loadWpPages, [])

    const laedt = event.loading || wpPages.loading
    useDocumentTitle((event.data && event.data.name) || '')
    // Fokus auf die h1 nach dem Laden (#178, #236): der Screenreader hoert den
    // Wechsel. Ohne Scrollen — die Seite beginnt oben.
    const headingRef = useFocusHeading(!laedt && !!event.data, { preventScroll: true })

    if (laedt) return <EventSkeleton variant="hub" />
    if (event.error || !event.data) return <p className="event-state" role="status">{LABELS.error}</p>

    return (
        <>
            {/* Ueber dem Zweispalter, nicht darin: die Leiste geht wie in der
                Live-Vorlage ueber die ganze Breite, nicht nur ueber den Inhalt
                rechts der Sidebar (#82). */}
            <EventBreadcrumb trail={eventTrail(event.data, null)} />
            <div className="event-columns">
                {/* Der Messename ist die h1 der Seite (Audit 2026-10-07, S3):
                    sichtbar als Titel des Sidebar-Kastens; ohne Sidebar nur fuer
                    Screenreader und Suchmaschinen. */}
                {event.data.sidebarHidden && <h1 className="jm-sr-only" tabIndex={-1} ref={headingRef}>{event.data.name}</h1>}
                <EventSidebar event={event.data} titleLevel={1} headingRef={event.data.sidebarHidden ? null : headingRef} />
                <div className="event-main">
                    {wpPages.error && <p className="event-state">{LABELS.wpPagesError}</p>}
                    <EventTiles eventSlug={eventSlug} tiles={joinWpTiles(event.data.tiles || [], wpPages.data || [])} />
                </div>
            </div>
        </>
    )
}

export default EventHub
